import { jsx as c, jsxs as f } from "react/jsx-runtime";
import P, { useRef as p, useCallback as b, useEffect as w } from "react";
import { createPortal as y } from "react-dom";
import t from "./style.module.less.js";
import M from "./more-vertical.svg.js";
import { useOnClickOutsideMultiple as k } from "../../../utils/on-click-outside.js";
const j = (m) => {
  const {
    items: $,
    className: a,
    activeClassName: x,
    menuItemsClassName: v,
    fixedPositioning: n,
    positioning: g
  } = m, [d, l] = P.useState(!1), r = p(null), o = p(null);
  k([r, o], () => l(!1));
  const h = b(
    (e) => {
      if (e.preventDefault(), e.stopPropagation(), l((s) => !s), n && o.current && r.current) {
        const { top: s, height: i, left: C, width: N } = r.current.getBoundingClientRect();
        o.current.style.top = `${s + i}px`, o.current.style.setProperty(
          "--context-menu-parent-width",
          `${N}px`
        ), o.current.style.setProperty(
          "--context-menu-left-position",
          `${C}px`
        );
      }
    },
    [n]
  );
  w(() => {
    if (n) {
      const e = () => l(!1);
      return window.addEventListener("scroll", e), () => window.removeEventListener("scroll", e);
    }
  }, [n]);
  const u = /* @__PURE__ */ c(
    "div",
    {
      className: `${t.contextMenu} 
    ${n ? t.fixedPositioning : ""} 
     ${g === "left" ? t.leftPositioning : ""} 
    ${d ? t.show : ""} 
    ${v ?? ""}
  `,
      ref: o,
      children: $.map((e, s) => /* @__PURE__ */ f(
        "div",
        {
          className: `${t.contextMenuItem} ${e.disabled ? t.disabled : ""} ${a ?? ""}`,
          onClick: (i) => {
            i.preventDefault(), i.stopPropagation(), e.disabled || (l(!1), e.onClick(i));
          },
          children: [
            /* @__PURE__ */ c("div", { className: t.label, children: e.label }),
            e.icon && /* @__PURE__ */ c("div", { className: t.icon, children: e.icon })
          ]
        },
        s
      ))
    }
  );
  return /* @__PURE__ */ f(
    "div",
    {
      className: `${t.contextMenuWrapper} ${a ?? ""} ${d ? `${t.open} ${n ? t.fixedPositioning : ""} ${x ?? ""}` : ""}`,
      onClick: h,
      ref: r,
      children: [
        /* @__PURE__ */ c(M, { className: t.menuIcon }),
        n ? y(u, document.body) : u
      ]
    }
  );
};
export {
  j as ContextMenu
};
